var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-card"},[_c('ActionBar',{attrs:{"title":_vm.$t('add_new_card')},on:{"click":_vm.handleSelect}},[_c('svg-icon',{attrs:{"slot":"icon","name":"card-icon","class-name":"card-icon"},slot:"icon"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }